module.exports = __webpack_public_path__ + "img/credential11.52e8ced1.png";